export const APP_NAME = 'Diffuser Dreams';
export const APP_LOGO_URL = '/basel/media/logo.png';
export const IMAGE_NOT_AVAILABLE = '/basel/media/logo.png';
